import i18n from "config/i18next";

i18n.addResources("es", "slotCreation", {
  slotCreation: "Creación de turno",
  regionLabel: "Región *",
  workzoneLabel: "Zona de operación *",
  capacityLabel: "Capacidad *",
  slotStartLabel: "Comienzo del turno *",
  slotEndLabel: "Fin del turno *",
  dateLabel: "Fecha *",
  regionPlaceholder: "Seleccioná la región",
  workzonePlaceholder: "Seleccioná la zona",
  capacityPlaceholder: "Ingresá la capacidad",
  slotStartPlaceholder: "Ingresá el horario de comienzo",
  slotEndPlaceholder: "Ingresá el horario de finalización",
  datePlaceholder: "Seleccioná la fecha",
  invalidTitle: "Ya existe un turno en ese rango",
  invalidMessage: "Por favor, verificá los datos e intentá nuevamente",
  validTitle: "Turno creado con éxito",
  validMessage: "El turno con código {{data}} fue creado correctamente",
  createSlotTitle: "Estás por crear un turno",
  createSlotMessage: "El mismo estará visible luego de confirmar",
  createSlotErrorTitle: "No es posible crear el turno",
  createSlotErrorMessage: "Por favor, verificá los datos e intentá nuevamente",
  minTimeDifferenceError:
    "La diferencia con el comienzo debe ser de al menos treinta minutos",
  maxTimeDifferenceError:
    "La diferencia con el comienzo no debe superar las seis horas",
  timeIntervalError: "Solo se admiten intervalos de 15 minutos",
});
